var $8505ccb37f34799e$exports = {};
$8505ccb37f34799e$exports = {
    "endTime": `\u{41A}\u{440}\u{430}\u{435}\u{43D} \u{447}\u{430}\u{441}`,
    "startTime": `\u{41D}\u{430}\u{447}\u{430}\u{43B}\u{435}\u{43D} \u{447}\u{430}\u{441}`,
    "time": `\u{412}\u{440}\u{435}\u{43C}\u{435}`
};


export {$8505ccb37f34799e$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
